import React from 'react';
import { externalContestsRegistry } from './registry';
import classes from './ExternalContestPage.module.css';
import ScrollLTR from '../../components/ui/scrollLTR/ScrollLTR';

const ExternalContestPage = ({ contest }) => {

  const Component = contest?.contestName ? externalContestsRegistry[contest.contestName] : null;

  if (!Component) return null;

  return (
    <ScrollLTR dropClass={classes.externalContestPage} >
      <div className={classes.externalContestPage}>
        <Component contest={contest} />
      </div>
    </ScrollLTR>
  )
};

export default ExternalContestPage;
